<template>
  <div>
    <!-- Page content -->
    <div class="container mt--9 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card  border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <small>Redefine password</small>
              </div>

              <form class="needs-validation" @submit.prevent="handleSubmit()">
                <div class="position-relative">
                  <base-input
                    alternative
                    class="input-group-alternative"
                    input-classes="input-icon"
                    :placeholder="showPassword ? 'Password' : '********'"
                    :type="showPassword ? 'text' : 'password'"
                    name="Password"
                    v-model="form.data.attributes.password"
                  >
                  </base-input>

                  <button 
                    type="button"
                    class="toggle-password-btn"
                    @click="togglePassword"
                  >
                    <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                  </button>
                </div>
                <validation-error :errors="apiValidationErrors.password" />

                <div class="position-relative mt-3 mb-3">
                  <base-input
                    alternative
                    class="input-group-alternative"
                    input-classes="input-icon"
                    :placeholder="showConfirmationPassword ? 'Password Confirmation' : '********'"
                    :type="showConfirmationPassword ? 'text' : 'password'"
                    name="confirmação de senha"
                    v-model="form.data.attributes.password_confirmation"
                  >
                  </base-input>

                  <button 
                    type="button"
                    class="toggle-password-btn"
                    @click="toggleConfirmationPassword"
                  >
                    <i :class="showConfirmationPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                  </button>
                </div>

                <div class="text-center">
                  <base-button type="primary" native-type="submit" class="my-4 submit"
                    >Redefine password</base-button
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ValidationError from "@/components/ui/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
export default {
  layout: "AuthLayout",
  mixins: [formMixin],
  components: { ValidationError },
  data() {
    return {
      form: {
        data: {
          type: "password-reset",
          attributes: {
            password: "",
            password_confirmation: "",
            token: "",
            email: "",
          },
        },
      },
      showPassword: false,
      showConfirmationPassword: false,
    };
  },
  mounted() {
    this.form.data.attributes.email = this.$route.query.email;
    this.form.data.attributes.token = this.$route.query.token;
  },
  beforeDestroy() {
    this.$router.replace({ query: null });
  },
  methods: {
    async handleSubmit() {
      try {
        await this.$store.dispatch("reset/createNewPassword", this.form.data);
      } catch (error) {
        await this.$notify({
          type: "danger",
          message: "Invalid data",
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmationPassword() {
      this.showConfirmationPassword = !this.showConfirmationPassword;
    },
  },
};
</script>

<style scoped>
>>> .argon-error {
  bottom: 0;
}

.position-relative {
  position: relative;
}

.toggle-password-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #8898aa;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.toggle-password-btn:hover {
  color: #525f7f;
}

/* Ensure the input padding accounts for the icon */
.input-group-alternative input {
  padding-right: 40px;
}
</style>